<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="10" offset-md="1" lg="8" offset-lg="2">
        <section id="Startups">
          <h1 class="text-center mt-16 font-weight-bold">Startups</h1>
          <ProjectComponent
            :imgSrcs="[
              '/img/projects/habitus/habitus-1.png',
              '/img/projects/project-habitus-technology-andromeda-mario-novak.png',
              '/img/projects/habitus/habitus-2.png',
              '/img/projects/habitus/habitus-3.png',
            ]"
            class="my-16"
            :headerLink="{
              name: '🏄 Habitus - Gamified Emotions, Habit Tracker and Journal',
              href: 'https://gethabitus.com/'
            }"
            :tags="[
              'TypeScript 3.8',
              'Koa.js 2.13.1',
              'Vue.js 2.6',
              'Vuetify 2.2',
              'Progressive Web App',
            ]"
            :descriptions="[
              'State-of-the-art Tracker for emotions, habits and thoughts.',
              'Open source.',
              'Anonymous.',
            ]"
            :points="[
              `Track emotions`,
              `Track thoughts (journal)`,
              `Track habits (good / bad)`,
              `Sound notifications`,
              `Performance graphs`,
              `Anonymous`,
              `Storing data only in your browser.`,
            ]"
            :links="[
              {
                name: 'Open the App',
                href: 'https://gethabitus.com/',
              },
              {
                name: 'Twitter: Page',
                href: 'https://twitter.com/HabitusToday',
              },
              {
                name: 'Medium: Page',
                href: 'https://medium.com/@habitus.today',
              },
              {
                name: 'GitHub: Frontend repo',
                href: 'https://github.com/AndromedaTechnology/habitus',
              },
              {
                name: 'GitHub: API repo',
                href: 'https://github.com/AndromedaTechnology/habitus-api',
              },
            ]"
          ></ProjectComponent>
          <ProjectComponent
            class="my-16"
            :imgSrcs="[
              '/img/projects/onetius-1.jpg',
              '/img/projects/project-onetius-technology-andromeda-mario-novak.jpg',
            ]"
            :headerLink="{
              name: '👨🏻‍🏫 Onetius - Slick and Powerful E-Learning Platform',
              href: 'https://onetius.com/'
            }"
            :tags="[
              'Leadership',
              'Product Development',
              'API Development - Laravel',
              'Frontend Development - backbone.js',
            ]"
            :descriptions="[
              `Learn from others or start your own Courses with your friends or colleagues.`,
              `Create Teams to host closed-down Courses for your Company, Family or Friends.`,
              `<strong>4900+ Teachers and Students.</strong>`,
            ]"
            :points="[
              `Open - Anyone can start or follow a course`,
              `Unbounded lessons - text, audio, video, photos`,
              `Test your knowledge - MicroExams after each lesson`,
              `Compare your performance with others - PerformanceGraph`,
              `Community discussions`,
              `Collaborations - People Nearby`,
              `Teams - Public, Private Courses`,
            ]"
            :links="[
              {
                name: 'Medium: Showcase article',
                href: 'https://medium.com/andromeda-technology/onetius-a-decade-ahead-of-its-time-the-e-learning-platform-edbdaf9f6d6a',
              },
              {
                name: 'YouTube: Pitch [VIDEO]',
                href: 'https://www.youtube.com/watch?v=tEkkxMh8JxE',
              },
              {
                name: 'YouTube: Channel',
                href: 'https://www.youtube.com/user/Onetius',
              },
              {
                name: 'Facebook: Page',
                href: 'https://facebook.com/Onetius',
              },
              {
                name: 'Press 1: MojaRijeka.hr',
                href: 'https://www.mojarijeka.hr/onetius-znanje-dostupno-svima-kroz-novu-mreznu-platformu/',
              },
              {
                name: 'Press 2: Netokracija.com',
                href: 'https://www.netokracija.com/onetius-edukativna-platforma-mario-novak-113910',
              },
            ]"
          ></ProjectComponent>
          <ProjectComponent
            class="my-16"
            imgSrc="/img/projects/shopify-syncer-connector-luceed-products-customers-inventory-orders-andromeda.webp"
            :headerLink="{
              name: '🛍️ Ceker.hr - Single place to get your Healthy foods from local Producers',
              href: 'https://ceker.hr/'
            }"
            :tags="[
              'Shopify',
              'MailChimp',
              'Google Suite',
              'Google Sheets',
              'Email, DNS management',
              'Technical Guidance',
            ]"
            :descriptions="[
              'Healthy foods directly from the Source!',
              'Tested, Certified, Home-grown, Natural foods.',
              'Providing Tourist Info inthe first Healthness Resort in Europe - Terme Sveti Martin',
            ]"
            :points="[
              `Online Store selling Healthy, Natural, Local Food from best Croatian producers`,
              `Natural Honey of all kinds`,
              `Natural, Healthy Chocolades`,
              `Hemp Flour`,
              `Hand-made Souvenirs`,
              `Single place to get your Healthy foods from local Producers`,
              `And much more! 🏡`,
            ]"
            :links="[
              {
                name: 'Visit the WebShop',
                href: 'https://ceker.hr/',
              },
              {
                name: 'Facebook: Page',
                href: 'https://facebook.com/medjimurskiCeker',
              },
              {
                name: 'TikTok: Page',
                href: 'https://tiktok.com/medjimurskiCeker',
              },
            ]"
          ></ProjectComponent>
          <ProjectComponent
            class="my-16"
            :imgSrcs="[
              '/img/projects/project-iron-heart-festival-technology-andromeda-mario-novak.jpg',
              '/img/projects/ihf-1.jpg',
            ]"
            :headerLink="{
              name: '💪 Iron Heart Festival - Sports Competition and Platform',
              href: 'https://ironheartfestival.com/'
            }"
            :tags="[
              'Leadership',
              'Marketing',
              'Product Development',
              'API Development - Laravel',
            ]"
            :descriptions="[
              `Sports Competition - Athletes compete for the title of <strong>'The most athletic individual on the Planet'</strong>.`,
              `Online Platform - educational videos, training logs of athletes.`,
              `<strong>7+ million views on YouTube.</strong>`,
              `<strong>20k+ subscribers on YouTube.</strong>`,
            ]"
            :points="[
              `Perfect mix of disciplines`,
              `Benchmark your speed, strength, agility`,
              `Compete with others once a year - at IHF Finals in Croatia`,
              `Track your progress online - Arena - Digital playground`,
              `Academy - Workshops and Lectures - Online and Offline in Croatia`,
            ]"
            :links="[
              {
                name: 'Google Docs: Booklet',
                href: 'https://docs.google.com/presentation/d/1mtKZiaNoi20_M2644vOoVItaEpQhodYhrDc5C_AVmAI/edit?usp=sharing',
              },
              {
                name: 'Youtube: Aftermovie',
                href: 'https://www.youtube.com/watch?v=dELRiTYFX70',
              },
              {
                name: 'YouTube: Channel',
                href: 'https://www.youtube.com/user/heartrequired/videos?view=0&sort=p&flow=grid',
              },
              {
                name: 'Facebook: Page',
                href: 'https://facebook.com/ironheartfestival',
              },
              {
                name: 'Press: Jutarnji.hr',
                href: 'https://www.jutarnji.hr/Promo/najbrze-rastuci-sportski-festival-u-europi-pocinje-za-11-dana-u-hrvatskoj/6484561/',
              },
            ]"
          ></ProjectComponent>
        </section>
        <section id="OpenSource">
          <h1 class="text-center my-16 py-16 font-weight-bold">Open source</h1>
          <ProjectComponent
            class="my-16"
            imgSrc="/img/projects/shopify-syncer-connector-luceed-products-customers-inventory-orders-andromeda.webp"
            :headerLink="{
              name: '🚀 Shopify Syncer - The Most Reliable Open-Source Shopify Connector',
              href: 'https://github.com/AndromedaTechnology/shopify-syncer-luceed'
            }"
            :tags="[
              'TypeScript',
              'Koa.js',
              'MongoDB',
              'Mongoose',
              'Jest',
              'Docker',
            ]"
            :descriptions="[
              `Manage your orders, products, inventory, customers.`,
              `Import Products and Inventory to Shopify from your system`,
              `Export Customers, Orders to your system`,
              `Now supporting: Luceed`,
            ]"
            :points="[
              'View, Create: Orders',
              'View, Create: Customers',
              'Sync Shopify Orders to Luceed',
              'Sync Luceed Products to Shopify',
              `Scalable architecture`,
              `Easy to extend`,
              `Bleeding-edge tools`,
            ]"
            :links="[
              {
                name: 'GitHub: API',
                href: 'https://github.com/AndromedaTechnology/shopify-syncer-luceed',
              },
              {
                name: 'Medium: Article',
                href: 'https://medium.com/andromeda-technology/the-most-reliable-open-source-shopify-connector-now-supporting-luceed-037776130f03',
              },
            ]"
          ></ProjectComponent>
          <ProjectComponent
            class="my-16"
            imgSrc="/img/projects/distoro-os.png"
            :headerLink="{
              name: '💻 Distoro OS - Operating System for x86 architecture',
              href: 'https://github.com/moltouni/distoro-os/'
            }"
            :tags="[
              'NASM',
              'C',
            ]"
            :descriptions="[
            `Uses FAT-12 filesystem, has working screen output, keyboard input,<br>
              exceptions, interrupts and allows for the usage of 4GB of RAM.`
            ]"
            :links="[
            {
              name: 'GitHub: Repository',
              href: 'https://github.com/moltouni/distoro-os/',
            },
            ]"
          ></ProjectComponent>
          <ProjectComponent
            class="my-16"
            imgSrc="/img/projects/firestarter-api.png"
            :headerLink="{
              name: '🚀 FireStarter API - Progressive Startup API Boilerplate',
              href: 'https://github.com/AndromedaTechnology/firestarter-api'
            }"
            :tags="[
              'TypeScript 3.8',
              'Koa.js 2.13.1',
              'MongoDB',
              'Mongoose',
              'Jest',
              'Docker',
            ]"
            :descriptions="[
              `Easy to extend, Progressive and Scalable API boilerplate to power your startup.`,
            ]"
            :points="[
              `Scalable architecture`,
              `Easy to extend`,
              `Bleeding-edge tools`,
            ]"
            :links="[
              {
                name: 'GitHub: API',
                href: 'https://github.com/AndromedaTechnology/firestarter-api',
              },
            ]"
          ></ProjectComponent>
          <ProjectComponent
            class="my-16"
            imgSrc="/img/projects/ethereum-hardhat-observer.png"
            :headerLink="{
              name: '🔭 Ethereum Observer',
              href: 'https://github.com/AndromedaTechnology/ethereum-observer-api'
            }"
            :tags="[
              'Blockchain',
              'Ethereum',
              'Hardhat',
              'Solidity',
              'TypeScript 3.8',
              'Koa.js 2.13.1',
              'MongoDB',
              'Mongoose',
              'Jest',
              'Docker',
            ]"
            :descriptions="[
              `Simple block and transaction tracker for Ethereum network. `,
            ]"
            :points="[
              `Tracking block and transaction creation`,
              `Storing daily summary to Solidity smart contract`,
            ]"
            :links="[
              {
                name: 'GitHub: API',
                href: 'https://github.com/AndromedaTechnology/ethereum-observer-api',
              },
              {
                name: 'GitHub: Hardhat',
                href: 'https://github.com/AndromedaTechnology/ethereum-observer-contract-hardhat',
              },
            ]"
          ></ProjectComponent>
        </section>
        <ScrollToTop class="py-16" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import ProjectComponent from './ProjectComponent.vue';
import ScrollToTop from './ScrollToTop.vue';

export default defineComponent({
  name: "StartupsComponent",
  components: {
    ProjectComponent,
    ScrollToTop,
  }
});
</script>
